var map = {
	"vs/base/common/worker/simpleWorker": 174
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 896;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/base/worker
// module id = 896
// module chunks = 0